import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Layout from './Partials/Layout';
import { ArrowRight, Check } from './Helpers/icons/Icons';

export default function Success() {
  const { t } = useTranslation();

  useEffect(() => {
    sessionStorage.removeItem('pendingProducts');
  }, []);

  return (
    <Layout>
      <div className='flex min-h-[560px] items-center bg-canvas py-20'>
        <div className='container-x'>
          <div className='mx-auto max-w-[520px] rounded-card border border-line bg-paper p-8 text-center md:p-12'>
            <span className='mx-auto mb-7 flex h-16 w-16 items-center justify-center rounded-pill bg-ink-900 text-apricot-400'>
              <Check size={30} />
            </span>

            <h1 className='display-md'>{t('payment_successful')}</h1>
            <p className='lede mt-4'>{t('payment_message')}</p>

            <div className='mt-9 flex flex-wrap justify-center gap-3'>
              <Link to='/profile#dashboard' className='btn btn-ink'>
                {t('sent_gift_cards')}
                <ArrowRight size={16} />
              </Link>
              <Link to='/products' className='btn btn-outline'>
                {t('gift_cards')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
